import defaultState, { DocsReducerInterface } from './defaultState'
import { ReduxAction } from '../reducerType'
import { syncType } from '../../actions/sync'
import { docsType } from '../../actions/docs'

export default function (state: DocsReducerInterface = defaultState, { type, payload }: ReduxAction): DocsReducerInterface {

  switch (type) {

    case docsType.SET_UI_DOCUMENT:
      return { ...state, uiDoc: payload }
    case docsType.SET_BOOKING_DOCUMENT:
      return { ...state, bookingDoc: payload }
    case docsType.SET_BRIDGE_DATA_DOCUMENT:
      return { ...state, bridgeDataDoc: payload }
    case docsType.SET_QUESTIONS_DOCUMENT:
      return { ...state, questionsDoc: payload }
    case docsType.REMOVE_BOOKING_DOC:
      return { ...state, bookingDoc: null }
    case docsType.REMOVE_BRIDGE_DATA_DOCUMENT:
      return { ...state, bridgeDataDoc: defaultState.bridgeDataDoc }
    case docsType.REMOVE_UI_DOC:
      return { ...state, uiDoc: null }
    case syncType.SYNC_CLIENT_ESTABLISHED:
      return { ...state, syncClient: payload }
    case docsType.SET_SEATING_ORDER_MAP:
      return { ...state, seatingOrderMap: payload }
    default:
      return state

  }

}
